import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper extends BaseFormMapper<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT);

		return _formData;
	}

	MapValues(): Partial<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT> {
		return {};
	}
}

const Mappings: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT = {
	selectedOption: 'Group5',
	electronicRegistration: 'Group4',
	certifications: 'certifications',
	acknowledgement: 'acknowledgement',
	province1: 'province1',
	province2: 'province2',
	enclosures: 'enclosures',
	solictorName: 'Name of Solicitors Firm',
	signature: 'signature',
	exceptions: 'Exceptions',
	dateYear: 'day of',
	datedAt: 'Date to be on or after date of final advance',
	dateDate:
		'The effect of the electronically registered documents has been fully explained to the parties signing the document',
	fireInsuranceAgent: 'Agent',
	fireInsurancePolicyNumber: 'Policy No',
	fireInsuranceName: 'Insurer',
	taxesPaidTo: 'Taxes paid to',
	mortgageAmount: 'Mortgage Amount',
	registrationDate: 'Registration Date',
	registryOffice: 'Land Registry Office',
	parcelIdentification: 'Parcel Identification No PIDPIN No if applicable',
	mortgageDate: 'Date of Mortgage',
	registrationNumber: 'Registration No',
	legalDescription: 'Full Legal Description of Property',
	address: 'Civic Address including Postal Code',
	mortgagor: 'Mortgagor',
	cibcReferenceNumber: 'CIBC REFERENCE NO',
};

export interface CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT {
	cibcReferenceNumber: string;
	mortgagor: string;
	address: string;

	legalDescription: string;

	electronicRegistration: string;
	registrationNumber: string;

	mortgageDate: string;
	parcelIdentification: string;

	registryOffice: string;
	registrationDate: string;

	mortgageAmount: string;
	taxesPaidTo: string;

	fireInsuranceName: string;
	fireInsurancePolicyNumber: string;
	fireInsuranceAgent: string;

	selectedOption: string;

	province1: string;
	province2: string;

	enclosures: string;
	acknowledgement: string;
	certifications: string;

	datedAt: string;
	dateDate: string;
	dateYear: string;

	solictorName: string;
	exceptions: string;
	signature: string;
}
